<template>
  <label class="soha-radio-button">
    <RadioButton
      :input-id="inputId"
      :name="name"
      :value="computedValue"
      :model-value="modelValue"
      :disabled="disable"
      class="soha-prime-radio-hidden"
      @update:model-value="handleUpdate"
    />
    <span
      class="radio-button-circle"
      :class="{ 'checked': isChecked }"
    />
    <span
      class="radio-button-text"
      :class="{ 'checked': isChecked, 'disabled': disable }"
    >
      {{ text }}
    </span>
  </label>
</template>

<script>
import { defineComponent, computed } from 'vue';
import RadioButton from 'primevue/radiobutton';

export default defineComponent({
  name: "SohaRadioButton",

  components: {
    RadioButton
  },

  props: {
    modelValue: {
      type: [String, Number, Boolean, Object],
      default: null
    },
    name: {
      type: String,
      default: null,
    },
    defaultValue: {
      type: [String, Number],
      required: true
    },
    text: {
      type: String,
      required: true
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },
  
  emits: ['update:modelValue'],

  setup(props, { emit }) {
    const computedValue = computed(() => {
      // تبدیل defaultValue به value برای PrimeVue
      return props.defaultValue;
    });

    const inputId = computed(() => {
      return `radio-${props.name}-${computedValue.value}`.replace(/\s+/g, '-');
    });

    const isChecked = computed(() => {
      return props.modelValue === props.defaultValue;
    });

    const handleUpdate = (selectedValue) => {      
      emit('update:modelValue', selectedValue);
    };

    return {
      computedValue,
      inputId,
      isChecked,
      handleUpdate
    };
  }
});
</script>

<style scoped>
.soha-radio-button {
    position: relative;
    margin: 0;
    display: flex;
    align-items: center;
}
.soha-prime-radio-hidden {
    opacity: 0 !important;
    position: absolute;
}
.soha-radio-button .radio-button-circle {
    position: relative;
    display: inline-block;
    min-width: 1.692rem;
    min-height: 1.692rem;
    border-radius: 50%;
    border: 0.154rem solid var(--tag-dark-gray-color);
    transition: all 0.3s;
    margin-left: 0.385rem;
}
.soha-radio-button .radio-button-circle.checked {
    border-color: var(--secondary-color);
}
.soha-radio-button .radio-button-text.checked {
    color: var(--secondary-color);
    transition: all 0.3s;
}
.soha-radio-button .radio-button-text.disabled {
    color: var(--inactive-color)!important;
}
.soha-radio-button .radio-button-circle.checked::after {
    content: "";
    position: absolute;
    right: 50%;
    top: 50%;
    transform: translate(50%, -50%);
    width: 0.769rem;
    height: 0.769rem;
    border-radius: 50%;
    background-color: var(--secondary-color);
}
.soha-radio-button .radio-button-text.disabled.checked::after {
    background-color: var(--inactive-color) !important;
}
.radio-button-text {
    font-size: 1.154rem;
    margin-top: 0.2rem;
}
</style>